export default __webpack_public_path__ + "static/media/08.b58bd32d.jpg";